<div class="{{(field.containerClass ? field.containerClass : 'col-md-6 d-inline-flex mb-4')}}">
    <div class="field-input w-100">
        <label class="form-labels">{{field.label}} <span *ngIf="field.required" class="text-danger">*</span></label>
        <mat-form-field class="form-control" [formGroup]="group">
            
            <mat-select [disabled]="field.disabled"  [formControlName]="field.name" (selectionChange)="onChange($event)">
                <mat-option *ngFor="let v of field.options" [value]="v.value">{{v.label}}</mat-option>
            </mat-select>
            <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
                <mat-error *ngIf="group.get(field.name).hasError(validation.name)" style="font-size: 12px;margin-top: 8px;">
                    {{validation.message}}
                </mat-error>
            </ng-container>
        </mat-form-field>
    </div>
</div>